import { useState } from 'react';
import { ChevronDown, Info } from 'lucide-react';

export const REGISTER_AMOUNT_NOTE =
  'ADP payroll register: negative amounts are converted to positive for matching, except rows where Wage Type Long Text is "Net payments/Deductions" (those stay negative).';

export default function ReconNotes({ notes, linesNormalized }) {
  const [open, setOpen] = useState(false);
  const items = notes?.length
    ? notes
    : [{ id: 'default', title: 'Register amount sign', text: REGISTER_AMOUNT_NOTE }];

  return (
    <div className="card-panel overflow-hidden">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex w-full items-center justify-between gap-2 px-4 py-3 text-left text-sm font-medium text-slate-200 hover:bg-slate-800/50"
      >
        <span className="inline-flex items-center gap-2">
          <Info className="h-4 w-4 text-cyan-500" />
          Reconciliation notes ({items.length})
        </span>
        <ChevronDown className={`h-4 w-4 text-slate-500 transition ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && (
        <div className="space-y-2 border-t border-slate-700 px-4 pb-4 pt-2">
          {items.map((n) => (
            <div
              key={n.id}
              className="rounded-lg border border-slate-700/80 bg-slate-800/60 px-3 py-2.5 text-sm text-slate-300"
            >
              <p className="font-medium text-slate-100">{n.title || 'Note'}</p>
              <p className="mt-1 leading-relaxed">{n.text}</p>
            </div>
          ))}
          {linesNormalized != null && linesNormalized > 0 && (
            <p className="text-xs text-slate-500">
              Last run: {linesNormalized.toLocaleString()} register line(s) had negative amounts normalized
              (excluding Net payments/Deductions).
            </p>
          )}
        </div>
      )}
    </div>
  );
}
